<template>
  <div id="not-found">
    <h1>Stránka nenalezena.</h1>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>
